import * as React from "react";

import { cn } from "@/lib/utils";

type SkeletonVariant = "rectangular" | "circular" | "text";

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /** CSS width value or number (px). */
  width?: string | number;
  /** CSS height value or number (px). */
  height?: string | number;
  /** Shape variant. Defaults to "rectangular". */
  variant?: SkeletonVariant;
}

const variantClasses: Record<SkeletonVariant, string> = {
  rectangular: "rounded-md",
  circular: "rounded-full",
  text: "rounded-md h-4",
};

const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, width, height, variant = "rectangular", style, ...props }, ref) => (
    <div
      ref={ref}
      aria-hidden="true"
      className={cn(
        "bg-muted motion-safe:animate-pulse",
        variantClasses[variant],
        className,
      )}
      style={{
        width: typeof width === "number" ? `${width}px` : width,
        height: typeof height === "number" ? `${height}px` : height,
        ...style,
      }}
      {...props}
    />
  ),
);
Skeleton.displayName = "Skeleton";

export { Skeleton };
export type { SkeletonProps, SkeletonVariant };
